var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.399 22.78a.85.85 0 0 0 1.202 1.202L21.632 5.951a.85.85 0 0 0-1.202-1.202L2.4 22.78Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.297 21.758H5.827l1.618-1.617h9.852a1.851 1.851 0 0 0 1.847-1.848v-7.831a1.855 1.855 0 0 0-.631-1.39l1.147-1.147a3.469 3.469 0 0 1 1.107 2.537v.881l3.155-2.283a1.363 1.363 0 0 1 1.388 0c.432.248.7.708.69 1.205v8.23a1.386 1.386 0 0 1-2.082 1.2l-3.156-2.284v.882a3.466 3.466 0 0 1-3.465 3.465Zm7.085-3.671-3.62-2.551v-2.322l3.62-2.55v7.423Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.465 8.614h8.698l1.617-1.618H5.465A3.466 3.466 0 0 0 2 10.462v7.83c0 .707.211 1.363.574 1.911l1.191-1.191a1.86 1.86 0 0 1-.147-.72v-7.83c0-1.018.825-1.843 1.847-1.848Z",
    fill: "#fff"
  })));
};
export default SvgVideoOff;